import { render, staticRenderFns } from "./TaskAddStageDialog.vue?vue&type=template&id=7dada0c1&scoped=true&"
import script from "./TaskAddStageDialog.vue?vue&type=script&lang=js&"
export * from "./TaskAddStageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dada0c1",
  null
  
)

export default component.exports